import * as commonConsts from '../../pages/common/CommonConsts';
import { getExistingAddressLine } from '../../utils/Helper';
import { format2FAAddress } from 'utils/FormatHelper';
import { getAddressLine } from '../annualReturn/FormatHelper';
import {
  getIndexOfValueInArray,
  getPremiseAddressLine,
  getDuplicateAddressDetailWthOutAddressNotChanged
} from '../../utils/Helper';
import { getValidatorsPersonalDetails } from './PersonalDetails/Validator';
import { getValidatorsAuthorityHolder } from './organisation/AuthorityHolder/Validator';
import {
  getAddValidatorsOrganisationAuditor,
  getEditValidatorsOrganisationAuditor
} from './organisation/Auditor/Validator';
import { getAddValidatorsIndividualAuditor, getEditValidatorsIndividualAuditor } from './individual/Auditor/Validator';
import { validateWithoutState } from '../Validation';
import * as fundRaisingValidators from '../../utils/notificationChange/fundraisingDetails/validators';

const getFullName = (firstName, middleName, lastName) => {
  if (middleName) {
    return `${firstName} ${middleName} ${lastName}`;
  }

  return `${firstName} ${lastName}`;
};

const getExistingTrader = (trader, type) => {
  const result = {
    id: trader.id,
    integrationId: trader.integrationId,
    firstName: trader?.firstName,
    lastName: trader?.lastName,
    middleName: trader?.middleName,
    name: getFullName(trader?.firstName, trader?.middleName, trader?.lastName),
    type: type,
    organisationName: trader?.businessName,
    primaryContact: trader?.contactNo
      ? {
          prefix: trader?.contactNo
            ? trader?.contactNo.split('-').length > 1
              ? trader?.contactNo.split('-')[0]
              : null
            : null,
          number: trader?.contactNo
            ? trader?.contactNo.split('-').length > 1
              ? trader?.contactNo.split('-')[1]
              : null
            : null
        }
      : {
          prefix: null,
          number: null
        },
    email: trader?.emailAddress,
    isExists: true,
    // isRemoved: trader?.isRemoved === true ? true : false,
    businessAddress:
      trader.addresses && trader.addresses.length > 0
        ? getExistingAddressLine(trader.addresses, commonConsts.BusinessAddressType)
        : '',
    postalAddress:
      trader.addresses && trader.addresses.length > 0
        ? getExistingAddressLine(trader.addresses, commonConsts.PostalAddressType)
        : '',
    isViewable: true
  };

  return result;
};

const getExistingBranch = (branch) => {
  const businessAddress =
    branch.addresses && branch.addresses.length > 0
      ? getExistingAddressLine(branch.addresses, commonConsts.BusinessAddressType)
      : '';

  const postalAddress =
    branch.addresses && branch.addresses.length > 0
      ? getExistingAddressLine(branch.addresses, commonConsts.PostalAddressType)
      : '';

  const result = {
    id: branch.id,
    integrationId: branch.integrationId,
    roles: branch.roles,
    orgHasContactDetails: 'No',
    organisationName: branch.businessName,
    organisationEmailAddress: '',
    sameAsOrganisationBusinessFlag: businessAddress === postalAddress,
    organisationPrimaryContact: {},
    registrationNumber: branch.abn,
    yinc: branch.yinc,
    type: 'organisation',
    isExists: true,
    // isRemoved: false,
    businessAddress: businessAddress,
    postalAddress: postalAddress,
    isViewable: true
  };

  return result;
};

const getTraderDetails = (trader, individualTraders, organisationTraders) => {
  let newTraderList = [];

  // existing organisation traders
  if (organisationTraders && organisationTraders.length > 0) {
    const tempNewTraders = organisationTraders.map((x) => {
      return getExistingTrader(x, commonConsts.OptionsOrganisation);
    });
    newTraderList = newTraderList.concat(tempNewTraders);
  }

  // existing individual traders
  if (individualTraders && individualTraders.length > 0) {
    const tempNewTraders = individualTraders.map((x) => {
      return getExistingTrader(x, commonConsts.OptionsIndividual);
    });
    newTraderList = newTraderList.concat(tempNewTraders);
  }

  // New Traders
  if (trader?.newTraders && trader.newTraders.length > 0) {
    const tempNewTraders = trader.newTraders.map((x) => {
      return x;
    });

    newTraderList = newTraderList.concat(tempNewTraders);
  }

  // Removed Traders
  if (trader?.removedTraders && trader.removedTraders.length > 0) {
    const tempNewTraders = [];
    newTraderList.forEach(function (b) {
      if (trader.removedTraders.filter((rb) => rb.id === b.id).length === 0) {
        tempNewTraders.push(b);
      }
    });

    newTraderList = tempNewTraders;
  }

  return {
    traderList: newTraderList,
    hasTraderList: newTraderList && newTraderList.length > 0,
    engageNewTrader:
      typeof trader?.engageNewTrader === 'boolean' ? trader?.engageNewTrader : newTraderList && newTraderList.length > 0
  };
};

const getBranchDetails = (branch, branchList) => {
  let newBranchList = [];
  // existing branches
  if (branchList && branchList.length > 0) {
    const tempNewBranches = branchList.map((x) => {
      return getExistingBranch(x);
    });
    newBranchList = newBranchList.concat(tempNewBranches);
  }

  // New Branches
  if (branch?.newBranches && branch.newBranches.length > 0) {
    const tempNewBranches = branch.newBranches.map((x) => {
      return x;
    });

    newBranchList = newBranchList.concat(tempNewBranches);
  }

  // Removed Branches
  if (branch?.removedBranches && branch.removedBranches.length > 0) {
    const tempNewBranches = [];
    newBranchList.forEach(function (b) {
      if (branch.removedBranches.filter((rb) => rb.id === b.id).length === 0) {
        tempNewBranches.push(b);
      }
    });

    newBranchList = tempNewBranches;
  }

  return {
    branchList: newBranchList,
    hasBranchList: newBranchList && newBranchList.length > 0,
    engageNewBranch:
      typeof branch?.engageNewBranch === 'boolean' ? branch?.engageNewBranch : newBranchList && newBranchList.length > 0
  };
};

const getIndividualApplicantDetails = (individualLicence, individualAuthorityHolder, twoFA, licenceInfo) => {
  const { twoFaVerified, data } = twoFA;
  const partyRowId = licenceInfo?.individualLicensee?.id;
  const integrationId = licenceInfo?.individualLicensee?.integrationId;

  const firstName =
    individualAuthorityHolder && individualAuthorityHolder?.firstName
      ? individualAuthorityHolder.firstName
      : twoFaVerified
      ? data?.firstName
      : '';

  const middleName =
    individualAuthorityHolder && individualAuthorityHolder?.middleName
      ? individualAuthorityHolder.middleName
      : twoFaVerified
      ? data?.middleName
      : '';

  const lastName =
    individualAuthorityHolder && individualAuthorityHolder?.lastName
      ? individualAuthorityHolder.lastName
      : twoFaVerified
      ? data?.lastName
      : '';

  const dateOfBirth = twoFaVerified
    ? data?.day
      ? data?.day + '/' + data?.month + '/' + data?.year
      : null
    : individualLicence && individualLicence.dob
    ? individualLicence.dob
    : null;

  const authorityHolderName = middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`;

  const emailAddress = individualLicence?.emailAddress
    ? individualLicence.emailAddress
    : twoFaVerified && data?.emailAddress
    ? data.emailAddress
    : null;

  const mobile = individualLicence?.primaryContactNumber
    ? individualLicence.primaryContactNumber
    : twoFaVerified && data?.mobileNumber
    ? data.mobileNumber
    : null;

  const secondaryContact =
    individualLicence && individualLicence.secondaryContactNumber
      ? {
          prefix: individualLicence.secondaryContactNumber.prefix,
          number: individualLicence.secondaryContactNumber.number
        }
      : twoFaVerified
      ? {
          prefix: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[0]
              : null
            : null,
          number: data?.phoneNumber
            ? data?.phoneNumber.split('-').length > 1
              ? data?.phoneNumber.split('-')[1]
              : null
            : null
        }
      : {
          prefix: null,
          number: null
        };

  let addresses = [];

  const twoFaDataResidentialAddress = twoFA.data.addressses.filter((x) => x.addressType === 'Residential');
  const residentialAddress =
    individualLicence?.residentialAddress?.addressType !== undefined
      ? { ...individualLicence.residentialAddress }
      : individualLicence?.residentialAddressPlaceholder
      ? {
          addressType: 'Residential',
          lookupValue: {},
          details: {
            Status: 'Success',
            Address: {
              addressLine1: twoFaDataResidentialAddress[0]?.addressLine,
              suburb: twoFaDataResidentialAddress[0]?.suburb,
              state: twoFaDataResidentialAddress[0]?.state,
              postcode: twoFaDataResidentialAddress[0]?.postCode,
              country: twoFaDataResidentialAddress[0]?.country
            }
          },
          addressNotChanged: false
        }
      : null;
  if (residentialAddress) {
    addresses = addresses.concat(residentialAddress);
  }

  const twoFaDataPostalAddress = twoFA.data.addressses.filter((x) => x.addressType === 'Postal');

  const postalAddress =
    individualLicence?.postalAddress?.addressType !== undefined
      ? { ...individualLicence.postalAddress }
      : individualLicence?.postalAddressPlaceholder
      ? {
          addressType: 'Postal',
          lookupValue: {},
          details: {
            Status: 'Success',
            Address: {
              addressLine1: twoFaDataPostalAddress[0]?.addressLine,
              suburb: twoFaDataPostalAddress[0]?.suburb,
              state: twoFaDataPostalAddress[0]?.state,
              postcode: twoFaDataPostalAddress[0]?.postCode,
              country: twoFaDataPostalAddress[0]?.country
            }
          },
          addressNotChanged: false
        }
      : null;
  if (postalAddress) {
    addresses = addresses.concat(postalAddress);
  }

  return {
    partyRowId,
    integrationId,
    firstName,
    middleName,
    lastName,
    dateOfBirth,
    authorityHolderName,
    emailAddress,
    mobile,
    secondaryContact,
    residentialAddress,
    postalAddress,
    addresses
  };
};

const getApplicantDetails = (twoFA, personalDetails, licenceInfo, authorityHolder) => {
  let isValid = true;
  let applicantDetails = personalDetails;

  //Check if applicant has any minimal required fields yet? if so thats what we use.
  if (personalDetails?.firstName || personalDetails?.lastName) {
    return {
      ...applicantDetails,
      invalid: false
    };
  }

  //Else use two FA data
  const twoFAData = twoFA.data;
  const residentialAddress =
    twoFAData.addressses && twoFAData.addressses.length > 0
      ? format2FAAddress(twoFAData.addressses, commonConsts.ResidentialAddressType)
      : '';
  const postalAddress =
    twoFAData.addressses && twoFAData.addressses.length > 0
      ? format2FAAddress(twoFAData.addressses, commonConsts.PostalAddressType)
      : '';

  // let dob;
  let existingApplicant;

  // if (twoFAData?.day && twoFAData?.month && twoFAData?.year) {
  //   dob = `${moment(twoFAData.year).format('YYYY')}-${moment(twoFAData?.month).format('MM')}-${moment(
  //     twoFAData?.month
  //   ).format('DD')}`;
  // }

  // if (
  //   licenceInfo?.organisationLicensee?.authorisedContacts &&
  //   licenceInfo?.organisationLicensee?.authorisedContacts.length > 0
  // ) {
  //   licenceInfo.organisationLicensee.authorisedContacts.forEach((contact) => {
  //     if (contact?.dateOfBirth && dob) {
  //       if (
  //         contact?.firstName === twoFAData?.firstName &&
  //         contact?.lastName === twoFAData?.lastName &&
  //         moment(contact.dateOfBirth).format('YYYY-MM-DD') === dob
  //       ) {
  //         existingApplicant = contact;
  //       }
  //     } else if (contact?.emailAddress && twoFAData?.emailAddress) {
  //       if (
  //         contact?.firstName === twoFAData?.firstName &&
  //         contact?.lastName === twoFAData?.lastName &&
  //         contact?.emailAddress === twoFAData?.emailAddress
  //       ) {
  //         existingApplicant = contact;
  //       }
  //     }
  //   });
  // }
  existingApplicant = getApplicant(twoFAData, licenceInfo);

  let primaryContactNumber = twoFAData?.mobileNumber;
  if (twoFAData?.mobileNumber) {
    if (twoFAData?.mobileNumber.includes('-')) {
      const primaryContactNumberParts = twoFAData?.mobileNumber.split('-');
      primaryContactNumber = primaryContactNumberParts[1];
    }
  }

  let secondaryContactNumber = { prefix: null, number: null };
  if (twoFAData?.phoneNumber) {
    if (twoFAData?.phoneNumber.includes('-')) {
      const secondaryContactNumberParts = twoFAData?.phoneNumber.split('-');
      secondaryContactNumber = { prefix: secondaryContactNumberParts[0], number: secondaryContactNumberParts[1] };
    } else {
      secondaryContactNumber = { prefix: null, number: twoFAData?.phoneNumber };
    }
  }

  const authorityHolderName =
    authorityHolder && authorityHolder?.authorityHolderName
      ? authorityHolder.authorityHolderName
      : licenceInfo?.authorityHolder && licenceInfo?.authorityHolder?.authorityHolderName
      ? licenceInfo?.authorityHolder?.authorityHolderName
      : '';

  const validators = getValidatorsPersonalDetails({
    emailAddress: twoFAData?.emailAddress,
    primaryContactNumber,
    secondaryContactNumber,
    sameAsResidentialFlag: residentialAddress === postalAddress,
    residentialAddress: residentialAddress,
    postalAddress: postalAddress,
    residentialAddressValid: residentialAddress === '' ? false : true,
    residentialAddressPlaceholder: residentialAddress,
    postalAddressValid: postalAddress === '' ? false : true,
    postalAddressPlaceholder: postalAddress
  });

  isValid = validateWithoutState(validators, []);

  applicantDetails = {
    id: existingApplicant ? existingApplicant?.id : null,
    integrationId: existingApplicant ? existingApplicant?.integrationId : null,
    role: existingApplicant ? existingApplicant?.roles : 'Contact Person',
    firstName: twoFAData?.firstName,
    middleName: twoFAData?.middleName,
    lastName: twoFAData?.lastName,
    authorityHolderName: authorityHolderName,
    dateOfBirth: existingApplicant?.dob ? existingApplicant.dob : null,
    emailAddress: twoFAData?.emailAddress,
    primaryContactNumber: primaryContactNumber,
    secondaryContactNumber: secondaryContactNumber,
    residentialAddressPlaceholder: residentialAddress,
    residentialAddress: null,
    postalAddressPlaceholder: postalAddress,
    postalAddress: null,
    sameAsResidentialFlag: residentialAddress === postalAddress,
    isEmailAddressValid: twoFAData?.emailAddress ? true : false,
    invalid: !isValid,
    finished: false,
    started: false
  };

  return applicantDetails;
};

const getApplicant = (twoFAData, licenceInfo) => {
  let existingApplicant = {};
  let dob;

  // if (twoFAData?.day && twoFAData?.month && twoFAData?.year) {
  //   dob = `${moment(twoFAData.year).format('YYYY')}-${moment(twoFAData?.month).format('MM')}-${moment(
  //     twoFAData?.month
  //   ).format('DD')}`;
  // }

  if (
    licenceInfo?.organisationLicensee?.authorisedContacts &&
    licenceInfo?.organisationLicensee?.authorisedContacts.length > 0
  ) {
    licenceInfo.organisationLicensee.authorisedContacts.forEach((contact) => {
      const contactFirstName = contact?.firstName ? contact.firstName.toLowerCase() : '';
      const contactLastName = contact?.lastName ? contact.lastName.toLowerCase() : '';
      const twoFAFirstName = twoFAData?.firstName ? twoFAData.firstName.toLowerCase() : '';
      const twoFALastName = twoFAData?.lastName ? twoFAData.lastName.toLowerCase() : '';

      if (
        contactFirstName === twoFAFirstName &&
        contactLastName === twoFALastName &&
        contact?.mobileNo === twoFAData?.mobileNumber
      ) {
        existingApplicant = contact;
      } else if (
        contactFirstName === twoFAFirstName &&
        contactLastName === twoFALastName &&
        contact?.emailAddress === twoFAData?.emailAddress
      ) {
        existingApplicant = contact;
      }
    });
  }

  return existingApplicant;
};

const getCompleteOrganisationAuthorityHolderDetails = (props) => {
  const {
    organisationDetail,
    organisationLicence,
    originalAuthorisedContacts,
    updatedAuthorisedContacts,
    newAuthorisedContacts,
    removedAuthorisedContacts
  } = props;
  let organisationAuthorityHolderDetails = { organisationDetail: {}, primaryContact: '', authorisedContacts: [] };

  organisationAuthorityHolderDetails.organisationDetail = getOrganisationLicenceDetails(
    organisationDetail,
    organisationLicence
  );

  organisationAuthorityHolderDetails.authorisedContacts = getAuthorisedContacts(
    originalAuthorisedContacts,
    updatedAuthorisedContacts,
    newAuthorisedContacts,
    removedAuthorisedContacts
  );

  organisationAuthorityHolderDetails.modified = organisationAuthorityHolderDetails.organisationDetail.modifed;
  organisationAuthorityHolderDetails.started = organisationAuthorityHolderDetails.organisationDetail.started;
  organisationAuthorityHolderDetails.invalid = !organisationAuthorityHolderDetails.organisationDetail.invalid;
  organisationAuthorityHolderDetails.status =
    organisationAuthorityHolderDetails.organisationDetail.finished ||
    organisationAuthorityHolderDetails.organisationDetail.started
      ? 'Modified'
      : 'Current';

  return organisationAuthorityHolderDetails;
};

const getOrganisationLicenceDetails = (organisationDetail, organisationLicence) => {
  let organisationLicenceDetails = {};
  let isValid = false;

  if (organisationLicence?.businessName) {
    organisationLicenceDetails = {
      abn: organisationLicence?.abn,
      acn: organisationLicence?.acn,
      yinc: organisationLicence?.yinc,
      businessName: organisationLicence?.businessName,
      organisationType: organisationLicence?.organisationType,
      isRegisteredWithAcnc: organisationLicence?.isRegisteredWithAcnc,
      authorityHolder: organisationLicence?.authorityHolder,
      premises: organisationLicence?.premises,
      addressRegisteredOfficeValue: organisationLicence?.addressRegisteredOfficeValue,
      otherAddresses: organisationLicence?.otherAddresses,
      sameAsRegisteredOffice: organisationLicence?.sameAsRegisteredOffice,
      finished: organisationLicence?.finished,
      started: organisationLicence?.started
    };
  } else {
    organisationLicenceDetails = {
      ...organisationDetail,
      addressRegisteredOfficeValue: null,
      otherAddresses: [],
      finished: false,
      started: false
    };
  }

  const isEmptyString = (str) => !str || !str.trim();

  var premiseAddress = organisationLicenceDetails.premises.find((obj) => {
    return obj.addressType === 'Registered Office';
  });

  const addressRegisteredOfficePlaceHolder =
    organisationLicenceDetails?.addressRegisteredOfficeValue?.lookupValue ||
    organisationLicenceDetails?.addressRegisteredOfficeValue?.enterManually == true
      ? getAddressLine(organisationLicenceDetails.addressRegisteredOfficeValue)
      : getPremiseAddressLine(premiseAddress);

  const addressBusinessPlaceholder =
    organisationLicenceDetails?.addressBusinessValue?.lookupValue ||
    organisationLicenceDetails?.addressBusinessValue?.enterManually == true
      ? getAddressLine(organisationLicenceDetails.addressBusinessValue)
      : getExistingAddressLine(organisationLicenceDetails.premises, 'Business');

  const addressPostalPlaceholder =
    organisationLicenceDetails?.addressPostalValue?.lookupValue ||
    organisationLicenceDetails?.addressPostalValue?.enterManually == true
      ? getAddressLine(organisationLicenceDetails?.addressPostalValue)
      : getExistingAddressLine(organisationLicenceDetails.premises, 'Postal');

  const sameAsRegisteredOffice =
    organisationLicenceDetails && organisationLicenceDetails.sameAsRegisteredOffice
      ? organisationLicenceDetails.sameAsRegisteredOffice
      : [false, false];

  const validators = getValidatorsAuthorityHolder({
    isAddressesValid: {
      firstAddressValid: !isEmptyString(addressRegisteredOfficePlaceHolder),
      otherAddressesValidDetail: [!isEmptyString(addressBusinessPlaceholder), !isEmptyString(addressPostalPlaceholder)]
    },
    addressRegisteredOfficePlaceHolder: addressRegisteredOfficePlaceHolder,
    sameAsRegisteredOffice: sameAsRegisteredOffice,
    addressBusinessPlaceholder: addressBusinessPlaceholder,
    addressPostalPlaceholder: addressPostalPlaceholder
  });
  organisationLicenceDetails.invalid = validateWithoutState(validators, []);

  return organisationLicenceDetails;
};

const getAuthorisedContacts = (
  originalAuthorisedContacts,
  updatedAuthorisedContacts,
  newAuthorisedContacts,
  removedAuthorisedContacts
) => {
  let authorisedContacts = [];

  if (updatedAuthorisedContacts?.length === 0) {
    originalAuthorisedContacts.map((contact) => {
      const i = getIndexOfValueInArray(contact.id, removedAuthorisedContacts, 'id');
      if (i === -1) {
        authorisedContacts = authorisedContacts.concat({
          id: contact?.id,
          integrationId: contact?.integrationId,
          firstName: contact?.firstName,
          middleName: contact?.middleName,
          lastName: contact?.lastName,
          emailAddress: contact?.emailAddress,
          mobileNumber: contact?.mobileNo
        });
      }
    });
  }

  if (newAuthorisedContacts?.length > 0) {
    newAuthorisedContacts.map((contact) => {
      const i = removedAuthorisedContacts.findIndex(
        (removedContact) =>
          removedContact.firstName === contact.firstName &&
          removedContact.middleName === contact.middleName &&
          removedContact.lastName === contact.lastName
      );
      if (i === -1) {
        authorisedContacts = authorisedContacts.concat({
          firstName: contact?.firstName,
          middleName: contact?.middleName,
          lastName: contact?.lastName,
          emailAddress: contact?.emailAddress,
          mobileNumber: contact?.mobileNo,
          create: contact?.create
        });
      }
    });
  }

  return authorisedContacts;
};

const mapExistingIndividualAuditor = (existingIndividualAuditor) => {
  const name = existingIndividualAuditor?.middleName
    ? `${existingIndividualAuditor?.firstName} ${existingIndividualAuditor?.middleName} ${existingIndividualAuditor?.lastName}`
    : `${existingIndividualAuditor?.firstName} ${existingIndividualAuditor?.lastName}`;

  const businessAddress =
    existingIndividualAuditor?.addresses && existingIndividualAuditor?.addresses?.length > 0
      ? getExistingAddressLine(existingIndividualAuditor?.addresses, commonConsts.BusinessAddressType)
      : '';

  const postalAddress =
    existingIndividualAuditor?.addresses && existingIndividualAuditor?.addresses?.length > 0
      ? getExistingAddressLine(existingIndividualAuditor?.addresses, commonConsts.PostalAddressType)
      : '';

  return {
    id: existingIndividualAuditor?.id,
    integrationId: existingIndividualAuditor?.integrationId,
    firstName: existingIndividualAuditor?.firstName,
    middleName: existingIndividualAuditor?.middleName,
    lastName: existingIndividualAuditor?.lastName,
    name: name,
    qualification: {
      qualifications: existingIndividualAuditor?.qualification?.qualifications
        ? existingIndividualAuditor?.qualification?.qualifications
        : '',
      certificateNumber: existingIndividualAuditor?.qualification?.certificateNumber
        ? existingIndividualAuditor?.qualification?.certificateNumber
        : '',
      details: existingIndividualAuditor?.qualification?.details
        ? existingIndividualAuditor?.qualification?.details
        : ''
    },
    partyType: commonConsts.OptionsIndividual,
    primaryContactNumber: {
      prefix: '',
      number: existingIndividualAuditor?.contactNo
    },
    emailAddress: existingIndividualAuditor?.emailAddress,
    roleId: existingIndividualAuditor?.role_Id,
    businessAddressPlaceholder: businessAddress,
    postalAddressPlaceholder: postalAddress
  };
};

const mapExistingOrganisationAuditor = (existingOrganisationAuditor) => {
  const leadAuditor = existingOrganisationAuditor?.relatedIndividual;
  return {
    id: existingOrganisationAuditor?.id,
    integrationId: existingOrganisationAuditor?.integrationId,
    businessName: existingOrganisationAuditor?.businessName,
    organisationData: {
      abn: existingOrganisationAuditor?.abn,
      acn: existingOrganisationAuditor?.acn,
      siebelRowId: existingOrganisationAuditor?.id,
      addresses: existingOrganisationAuditor?.addresses
    },
    yinc: existingOrganisationAuditor?.yinc,
    roleId: existingOrganisationAuditor?.role_id,
    startDate: existingOrganisationAuditor?.startDate,
    addresses: existingOrganisationAuditor?.addresses,
    premises: existingOrganisationAuditor?.premises,
    leadAuditor: {
      id: leadAuditor?.id,
      integrationId: leadAuditor?.integrationId,
      firstName: leadAuditor?.firstName,
      middleName: leadAuditor?.middleName,
      lastName: leadAuditor?.lastName,
      qualification: {
        qualifications: leadAuditor?.qualification?.qualifications ? leadAuditor?.qualification?.qualifications : '',
        certificateNumber: leadAuditor?.qualification?.certificateNumber
          ? leadAuditor?.qualification?.certificateNumber
          : '',
        details: leadAuditor?.qualification?.details ? leadAuditor?.qualification?.details : ''
      },
      primaryContactNumber: {
        prefix: leadAuditor?.primaryContactNumber?.prefix ? leadAuditor?.primaryContactNumber?.prefix : null,
        number: leadAuditor?.primaryContactNumber?.number ? leadAuditor?.primaryContactNumber?.number : null
      },
      contactNo: leadAuditor?.contactNo,
      emailAddress: leadAuditor?.emailAddress,
      addresses: leadAuditor?.addresses,
      roleId: leadAuditor?.role_Id,
      roleIntegrationId: leadAuditor?.roleIntegrationId
    },
    partyType: commonConsts.OptionsOrganisation
  };
};

const getAuditors = (existingAccountants, newAccountants, removedAccountants) => {
  let auditorList = [];
  let validators = [];

  newAccountants.forEach((newAccountant) => {
    if (newAccountant?.firstName && newAccountant?.lastName) {
      validators = getAddValidatorsIndividualAuditor({
        auditorType: newAccountant?.partyType,
        individualFirstName: newAccountant?.firstName,
        individualLastName: newAccountant?.lastName,
        individualQualification: newAccountant?.qualification,
        individualEmailAddress: newAccountant?.emailAddress,
        individualPrimaryContactNumber: newAccountant?.primaryContactNumber,
        individualSameAsBusinessFlag: newAccountant?.individualSameAsBusinessFlag,
        individualBusinessAddress: newAccountant?.businessAddress,
        individualPostalAddress: newAccountant?.postalAddress,
        individualIsBusinessAddressValid: newAccountant?.businessAddress ? true : false,
        individualIsPostalAddressValid: newAccountant?.postalAddress ? true : false
      });
    } else {
      validators = getAddValidatorsOrganisationAuditor({
        // auditorType,
        // organisationData,
        // newAccountants,
        // organisationSearchCriteria,
        // registrationNumber,
        // organisationName,
        // organisationContactFirstName,
        // organisationContactLastName,
        // organisationContactQualification,
        // organisationContactEmailAddress,
        // organisationContactPrimaryContactNumber,
        // organisationContactBusinessAddress,
        // organisationContactPostalAddress,
        // isOrganisationContactBusinessAddressValid,
        // organisationContactSameAsBusinessFlag,
        // isOrganisationContactPostalAddressValid
      });
    }

    newAccountant.started = newAccountant?.started ? newAccountant.started : false;
    newAccountant.finished = newAccountant?.finished ? newAccountant.finished : false;
    newAccountant.inValid = validateWithoutState(validators, []);

    auditorList.push(newAccountant);
  });

  existingAccountants.forEach((updatedAccountant) => {
    if (updatedAccountant?.firstName && updatedAccountant?.lastName) {
      validators = getEditValidatorsIndividualAuditor({
        individualQualification: updatedAccountant?.qualification
      });
    } else {
      validators = getEditValidatorsOrganisationAuditor({
        // auditorType,
        // organisationData,
        // newAccountants,
        // organisationSearchCriteria,
        // registrationNumber,
        // organisationName,
        // organisationContactFirstName,
        // organisationContactLastName,
        // organisationContactQualification,
        // organisationContactEmailAddress,
        // organisationContactPrimaryContactNumber,
        // organisationContactBusinessAddress,
        // organisationContactPostalAddress,
        // isOrganisationContactBusinessAddressValid,
        // organisationContactSameAsBusinessFlag,
        // isOrganisationContactPostalAddressValid
      });
    }

    updatedAccountant.started = updatedAccountant?.started ? updatedAccountant.started : false;
    updatedAccountant.finished = updatedAccountant?.finished ? updatedAccountant.finished : false;
    updatedAccountant.inValid = validateWithoutState(validators, []);

    auditorList.push(updatedAccountant);
  });

  return auditorList;
};

const getExistingAuditors = (currentIndividualAuditor, currentOrganisationAuditor) => {
  let existingAuditorsList = [];

  if (currentIndividualAuditor?.auditors?.length > 0) {
    currentIndividualAuditor.auditors.map((auditor) => {
      existingAuditorsList = existingAuditorsList.concat(mapExistingIndividualAuditor(auditor));
    });
  }

  if (currentOrganisationAuditor?.auditors?.length > 0) {
    currentOrganisationAuditor.auditors.map((auditor) => {
      existingAuditorsList = existingAuditorsList.concat(mapExistingOrganisationAuditor(auditor));
    });
  }

  return existingAuditorsList;
};

const getFundraisingDetails = (existingFundraisingDetail, fundraisingDetail) => {
  let fundraisingDetails = {};

  if (fundraisingDetail?.charityObject) {
    fundraisingDetails = fundraisingDetail;
  } else {
    let day = null;
    let month = null;
    if (existingFundraisingDetail?.financialYearEndDate) {
      const financialYearEndDateParts = existingFundraisingDetail?.financialYearEndDate.split('/');
      if (financialYearEndDateParts?.length === 2) {
        day = financialYearEndDateParts[0];
        month = financialYearEndDateParts[1];
      }
    }

    fundraisingDetails = {
      charityObjectId: existingFundraisingDetail?.charityObjectId,
      charityObject: existingFundraisingDetail?.charityObject,
      natureDuration: existingFundraisingDetail?.natureDuration,
      directorRemuneration: existingFundraisingDetail?.directorRem,
      applicantOrgType: existingFundraisingDetail?.applicantOrgType,
      financialYearEndDate: existingFundraisingDetail?.financialYearEndDate,
      charityWebsiteUrl: existingFundraisingDetail?.charityWebsiteUrl,
      day: day,
      month: month
    };
  }

  return fundraisingDetails;
};

const getOrganisationType = (existingOrganisationLicence, organisationLicence) => {
  let orgType = commonConsts.ORG_TYPE_Other;
  if (organisationLicence?.organisationType) {
    orgType = organisationLicence?.organisationType;
  } else if (existingOrganisationLicence?.organisationDetail?.organisationType) {
    orgType = existingOrganisationLicence?.organisationDetail?.organisationType;
  }

  if (
    orgType !== commonConsts.ORG_TYPE_Unincorporated &&
    orgType !== commonConsts.ORG_TYPE_TrustDeed &&
    orgType !== commonConsts.ORG_TYPE_IncorporatedAssociationNSW &&
    orgType !== commonConsts.ORG_TYPE_CompanyLtdShares &&
    orgType !== commonConsts.ORG_TYPE_CompanyLimitedGuarantee
  ) {
    orgType = commonConsts.ORG_TYPE_Other;
  }

  return orgType;
};

const getManualAddress = (address) => {
  if (address) {
    return {
      addressLine: address.addressLine,
      suburb: address.suburb,
      state: address.state.value ? address.state.value : address.state,
      postCode: address.postcode ? address.postcode : address.postCode,
      country: address.country
    };
  }
  return null;
};

const getSingleAddressDetail = (primaryAddress, addressType) => {
  let address = [];
  let addrType = addressType ? addressType : primaryAddress.addressType;
  if (primaryAddress && primaryAddress.addressNotChanged === false) {
    if (primaryAddress && !primaryAddress.international) {
      address = address.concat({
        addressType: addrType,
        enterManually: primaryAddress.enterManually,
        manualAddress: !primaryAddress.lookupValue ? getManualAddress(primaryAddress) : {},
        lookupValue: primaryAddress.lookupValue ? primaryAddress.lookupValue : {},
        details: primaryAddress.details ? primaryAddress.details : {},
        addressNotChanged: primaryAddress.addressNotChanged
      });
    } else if (primaryAddress && primaryAddress.international) {
      address = address.concat({
        addressNotChanged: primaryAddress.addressNotChanged,
        addressType: addrType,
        details: {
          Status: 'Success',
          Address: {
            addressLine1: primaryAddress.addressLine,
            suburb: primaryAddress.suburb,
            state: primaryAddress.state,
            postcode: primaryAddress.postcode,
            country: primaryAddress.country
          }
        }
      });
    }
  } else if (primaryAddress) {
    address = address.concat({
      addressType: addrType,
      addressNotChanged: primaryAddress.addressNotChanged
    });
  }

  return address;
};

const getExistingAddressDetail = (addressList, addressType) => {
  let address = [];
  if (addressList && addressList.length > 0) {
    const addr = addressList.find((a) => a.addressType === addressType);

    if (addr) {
      address = address.concat({
        addressNotChanged: true,
        addressType: addressType,
        details: {
          Status: 'Success',
          Address: {
            addressLine1: addr.addressLine1,
            suburb: addr.suburb,
            state: addr.state,
            postcode: addr.postcode,
            country: addr.country
          }
        }
      });
    }
  }

  return address;
};

const getFundraisingDetailWithStatus = (existingFundraisingDetail, fundraisingDetail, authorityInformation) => {
  const fundrasingDetails = getFundraisingDetails(existingFundraisingDetail, fundraisingDetail);
  // exisitng fundrasingDetails
  if (fundraisingDetail?.charityObject) {
    return fundrasingDetails;
  }

  // modified fundraisngDetails
  const fundRaisingValidatorRule = fundRaisingValidators.fundRaisingDetailValidatorRule({
    charityObject: fundrasingDetails?.charityObject,
    natureDuration: fundrasingDetails?.natureDuration,
    directorRemuneration: fundrasingDetails?.directorRemuneration,
    authorityInformation: authorityInformation,
    applicantOrgType: fundrasingDetails?.applicantOrgType,
    day: fundrasingDetails?.day,
    month: fundrasingDetails?.month
  });

  const isFundraisingDetailValid = validateWithoutState(fundRaisingValidatorRule, []);

  return {
    ...fundrasingDetails,
    started: !isFundraisingDetailValid,
    finished: isFundraisingDetailValid,
    status: 'Current'
  };
};

export {
  getIndividualApplicantDetails,
  getTraderDetails,
  getBranchDetails,
  getApplicantDetails,
  getApplicant,
  getCompleteOrganisationAuthorityHolderDetails,
  getOrganisationLicenceDetails,
  getAuthorisedContacts,
  getAuditors,
  getExistingAuditors,
  getFundraisingDetails,
  getOrganisationType,
  getSingleAddressDetail,
  getExistingAddressDetail,
  getFundraisingDetailWithStatus
};
